<template>
	<div class="match">
		<!-- <div class="header">
			
		</div> -->
		<div class="left">
			<NavMens :homeName.sync="homeName" :awayName.sync="awayName" :status.sync="status" :match_id.sync="match_id"/>
		</div>
		<div class="right">
			<div class="nav">
				<span @click="tabs = 1" :class="{avtion: tabs == 1}">事件直播</span>
				<span @click="tabs = 2" :class="{avtion: tabs == 2}">球队阵容</span>
				<span @click="tabs = 3" :class="{avtion: tabs == 3}">数据分析</span>
			</div>
			<div class="logo">
				<img src="../../assets/img/matchDetails/logo_one2.png" alt="">
				<!-- <div class="mode">
					<div>
						<img src="https://data.shemen365.com/img/qr.png" alt="">
					</div>
					<p>本赛事数据由</p>
					<p><em>V站官方APP</em>提供支持</p>
				</div> -->
			</div>
			<div class="main">
				<Live v-if="match_id" :status="status" :match_id="match_id" :tabs="tabs" v-show="tabs == 1"/>
				<Lineup v-if="match_id" :status="status" :match_id="match_id" :tabs="tabs" v-show="tabs == 2"/>
				<CharsData v-if="match_id" :status="status" :away_team_name="awayName" :home_team_name="homeName" :match_id="match_id" :tabs="tabs" v-show="tabs == 3"/>
			</div>
		</div>
	</div>
</template>

<script>
import NavMens from "../../components/match/navMens.vue"
import Live from "./live"
import Lineup from "./lineup"
import CharsData from "./charsData"
export default {
	name: 'match',
	components: {
		NavMens,
		Live,
		Lineup,
		CharsData
	},
	data () {
		return {
			tabs: 1,
			match_id: null,
			homeName: '',
			awayName: '',
			status: ''
		}
	},
	watch: {
		status: {
			handler (news) {
				if (news == 1) {
					this.tabs = 2
				} else if (news == 2)  {
					this.tabs = 1
				} else if (news == 3) {
					this.tabs = 3
				}
			}
		}
	}
}
</script>

<style lang="less" scoped>
.match{
    box-sizing: border-box;
	overflow: hidden;
	width: 1224px;
	height: 1223px;
	// padding-top: 28px;
	// position: relative;
	// &::before{
	// 	content: '';
	// 	width: 150px;
	// 	height: 29px;
	// 	background: rgba(0, 0, 0, 0);
	// 	position: absolute;
	// 	transform: skewX(-50deg);
	// 	top: 0;
	// 	left: -20px;
	// 	border-bottom: 1px solid #FFD436;
	// 	border-right: 1px solid #FFD436 ;
	// }
	// &::after{
	// 	content: '';
	// 	width: 150px;
	// 	height: 29px;
	// 	background: rgba(0, 0, 0, 0);
	// 	position: absolute;
	// 	transform: skewX(50deg);
	// 	top: 0;
	// 	right: -20px;
	// 	// border: none;
	// 	border-bottom: 1px solid #FFD436;
	// 	border-left: 1px solid #FFD436 ;

	// }
	// border: 1px solid #FFD436;
	border-top: none;
	display: flex;
	justify-content: space-between;
	background: #fff;
	.left{
		width: 272px;
		// margin-right: 10px;
	}
	.right{
		flex: 1;
		// padding-left: 10px;
		.nav{
			display: flex;
			justify-content: flex-start;
			align-items: center;
			span{
				width: 164px;
				height: 50px;
				background: #E17177;
				border-radius: 4px;
				cursor: pointer;
				margin-right: 10px;
				font-size: 18px;
				font-weight: 400;
				line-height: 50px;
				text-align: center;
				color: #FFFFFF;
				transition: all 0.2s;
				&:hover{
					background: #AB1B23;
				}
			}
			.avtion{
				background: #AB1B23;
			}
		}
		.logo{
			margin-top: 10px;
			height: 45px;
			cursor: pointer;
			img{
				width: 100%;
			}
			position: relative;
			
			&:hover{
				.mode{
					display: block;
				}
			}
			.mode{
				display: none;
				position: absolute;
				z-index: 1000;
				right: 0;
				top: 45px;
				width: 200px;
				height: 210px;
				background: #A3180F;
				div{
					display: flex;
					justify-content: center;
					align-items: center;
					img{
						width: 130px;
					}
					margin: 20px 0 9px 0px;
				}
				p{
					font-size: 14px;
					font-weight: 400;
					color: #FFFFFF;
					text-align: center;
					em{
						font-style: normal;
						font-size: 16px;
						font-weight: bold;
					}
				}
			}
		}
		.main{
    		height: calc(100% - 110px ) ;
		}
	}
}
</style>